<template>
  <div class="action-config-item default-action p-4">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <p>{{ actionMessage }}</p>
  </div>
</template>

<script>
  export default {
    name: 'DefaultAction',
    props: {
      step: {
        type: Object,
        required: true,
      },
    },
    computed: {
      actionMessage() {
        const action = this.step?.action;
        switch (action) {
          case 'External Sources':
            return 'External Source configuration';
          case 'self/DELETE':
            return 'Current Data will be deleted';
          default:
            return `Action configuration for ${action || 'this action'} is not yet implemented.`;
        }
      },
    },
  };
</script>
